import styled from "styled-components";
import { colors, font, radius } from "../theme";

export const AppScroll = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 28px 30px 34px;
  font-family: ${font.body};
  color: ${colors.ink};
  background: ${colors.window};

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(29, 29, 31, 0.18);
    border-radius: ${radius.pill};
  }
`;

export const AppTitle = styled.h1`
  margin: 0 0 4px;
  font-size: 30px;
  line-height: 1.1;
  font-weight: 700;
`;

export const AppEyebrow = styled.div`
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 12px;
  font-weight: 700;
  color: ${colors.inkFaint};
  margin-bottom: 8px;
`;

export const AppLead = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: ${colors.inkSoft};
  margin: 0 0 16px;
  max-width: 60ch;
`;

export const SectionLabel = styled.h2`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.inkFaint};
  margin: 24px 0 12px;
  font-weight: 700;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px dashed rgba(29, 29, 31, 0.18);
  margin: 22px 0;
`;

export const Chip = styled.span<{ $bg?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: ${radius.pill};
  border: 2px solid ${colors.ink};
  background: ${({ $bg }) => $bg ?? colors.butter};
  font-size: 13px;
  font-weight: 600;
  color: ${colors.ink};
  white-space: nowrap;
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const PillButton = styled.button<{ $bg?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: ${radius.pill};
  border: 2px solid ${colors.ink};
  background: ${({ $bg }) => $bg ?? colors.green};
  color: ${colors.ink};
  font-family: ${font.body};
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
  box-shadow: 3px 3px 0 rgba(29, 29, 31, 0.2);

  &:hover {
    transform: translate(-1px, -1px);
    box-shadow: 4px 4px 0 rgba(29, 29, 31, 0.25);
  }
  &:active {
    transform: translate(1px, 1px);
    box-shadow: 1px 1px 0 rgba(29, 29, 31, 0.2);
  }
`;
